import React from 'react';
import {Animated, StyleSheet} from 'react-native';
import {withGlobalize} from 'react-native-globalize';
import {compose} from 'recompose';
import Localized from 'src/constants/AppStrings';
import withIsConnected from '../../hoc/withIsConnected';
import Styles from '../../Styles';
import buildTransform from '../../utils/BuildTransform';
import AVFormattedCurrency from '../AVFormattedCurrency';
import AccountStore from 'src/stores/AccountStore';
import AVText from '../AVText';
import Util from 'src/Util';
import {withSelfMeasure} from 'src/components/utils/SelfMeasureBehavior';

class AnimatedBalance extends React.Component<any> {
  render() {
    const {
      animationRange,
      onLayoutSetMeasurements,
      elementX,
      elementY,
      elementHeight,
      elementWidth,
      balance = 0,
      strings,
      calculateDestX,
      destY,
      isCentered,
    } = this.props;
    const animateBalance = buildTransform(
      animationRange,
      elementX,
      elementY,
      elementHeight,
      elementWidth,
      calculateDestX(elementX, elementWidth),
      destY,
      1,
    );
    const currency = AccountStore.getCurrency();

    const formattedCurrency = Util.formatCurrency(this, +balance, currency, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    const animateOpacity = {
      opacity: animationRange.interpolate({
        inputRange: [0, 1],
        outputRange: [1, 0],
      }),
    };
    return (
      <Animated.View
        style={[
          styles.balanceContainer,
          animateBalance,
          isCentered && styles.center,
        ]}
        onLayout={(event) => onLayoutSetMeasurements(event)}
        accessibilityLabel={
          strings.Labels.your_balance + ' is ' + formattedCurrency
        }
        nativeID={strings.Labels.your_balance + ' is ' + formattedCurrency}
      >
        <AVText style={styles.balanceLabel}>
          {strings.Labels.your_balance}
        </AVText>
        <AVFormattedCurrency
          accessibilityLabel="balance"
          style={styles.balance}
          value={balance}
        />
        {!this.props.isConnected ? (
          <Animated.Text style={[styles.updatedLabel, animateOpacity]}>{`${
            Localized.Labels.as_of
          } ${AccountStore.getDisplayDateAccountUpdated()}`}</Animated.Text>
        ) : null}
      </Animated.View>
    );
  }
}

const styles = StyleSheet.create({
  balance: {
    color: Styles.balanceColor,
    fontSize: Styles.Fonts.f3,
    fontWeight: '600',
  },
  balanceContainer: {
    alignItems: 'flex-end',
  },
  balanceLabel: {
    fontSize: Styles.Fonts.f1,
    fontWeight: '300',
  },
  center: {
    alignItems: 'center',
  },
  updatedLabel: {
    fontSize: Styles.Fonts.f0,
  },
});
const enhance = compose(withSelfMeasure);
export default enhance(withIsConnected(withGlobalize(AnimatedBalance)));
